import { GeoCascade } from "../../components/geo/GeoCascade";
import { CompanyPicker } from "../../components/platform/CompanyPicker";
import { SIZE_BUCKETS } from "./notifyBuckets";

const SEL = "w-full rounded-2xl bg-background px-3 py-2.5 text-sm shadow-neu-sm";
const CH = [["inapp", "داخل التطبيق"], ["push", "إشعار الجوال"], ["email", "بريد إلكتروني"]];

// فلاتر قابلة للجمع: الموقع (دولة/منطقة/مدينة) + حجم الشركة معاً. أو شركة محددة (تتجاوز الباقي).
export const NotifyFilters = ({ form, set, ch, setCh, companies }) => (
  <div className="grid gap-3">
    <p className="label-xs">إرسال مباشر لشركة بالاسم (يتجاوز بقية الفلاتر)</p>
    <CompanyPicker companies={companies} value={form.companyId} onChange={(id) => set((f) => ({ ...f, companyId: id }))} />
    <p className="label-xs mt-1">أو الاستهداف الجماعي — يمكن الجمع بين الموقع والحجم معاً</p>
    <GeoCascade prefix="notify-geo" value={{ country: form.country, region: form.region, city: form.city }}
      onChange={(patch) => set((f) => ({ ...f, ...patch }))} />
    <select data-testid="notify-size" className={SEL} value={form.bucket} onChange={(e) => set((f) => ({ ...f, bucket: e.target.value }))}>
      <option value="">أي حجم شركة</option>
      {SIZE_BUCKETS.map((b) => <option key={b.id} value={b.id}>{b.label} موظف</option>)}
    </select>
    <label className="flex items-center gap-2 text-sm font-semibold" data-testid="notify-admins-only">
      <input type="checkbox" checked={form.adminsOnly} onChange={(e) => set((f) => ({ ...f, adminsOnly: e.target.checked }))} />
      للمدراء/الأدمن فقط (بدل كل الموظفين)
    </label>
    <div className="flex flex-wrap gap-4">
      {CH.map(([k, l]) => (
        <label key={k} className="flex items-center gap-2 text-sm font-semibold" data-testid={`notify-ch-${k}`}>
          <input type="checkbox" checked={ch[k]} onChange={(e) => setCh((c) => ({ ...c, [k]: e.target.checked }))} /> {l}
        </label>
      ))}
    </div>
  </div>
);
